var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.999999L21 5L21 11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11L3 5L12 0.999999ZM12 4.9C11.4067 4.9 10.8266 5.07595 10.3333 5.40559C9.83994 5.73523 9.45542 6.20377 9.22836 6.75195C9.0013 7.30013 8.94189 7.90333 9.05764 8.48527C9.1734 9.06721 9.45912 9.60176 9.87868 10.0213C10.2982 10.4409 10.8328 10.7266 11.4147 10.8424C11.9967 10.9581 12.5999 10.8987 13.148 10.6716C13.6962 10.4446 14.1648 10.0601 14.4944 9.56671C14.8241 9.07336 15 8.49334 15 7.9C15 7.10435 14.6839 6.34129 14.1213 5.77868C13.5587 5.21607 12.7956 4.9 12 4.9ZM12 12.8C10 12.8 6 13.89 6 15.88C6.65677 16.8701 7.54836 17.6823 8.59527 18.2442C9.64218 18.806 10.8119 19.1 12 19.1C13.1881 19.1 14.3578 18.806 15.4047 18.2442C16.4516 17.6823 17.3432 16.8701 18 15.88C18 13.89 14 12.8 12 12.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.5bfc8061c10585a38fd606603e3a6d53.svg";
export { ForwardRef as ReactComponent };